export const skillSlugToName: Record<
  string,
  { name: string; subskills: Record<string, { name: string }> }
> = {
  discovery_qualification: {
    name: "Discovery & Qualification",
    subskills: {
      needs_assessment: { name: "Needs Assessment" },
      stakeholder_mapping: { name: "Stakeholder Mapping" },
      budget_qualification: { name: "Budget Qualification" },
      timeline_establishment: { name: "Timeline Establishment" },
      decision_process_understanding: {
        name: "Decision Process Understanding",
      },
      competitive_landscape_analysis: {
        name: "Competitive Landscape Analysis",
      },
      pain_point_identification: { name: "Pain Point Identification" },
      buying_criteria_clarification: { name: "Buying Criteria Clarification" },
    },
  },
  rapport_communication: {
    name: "Rapport & Communication",
    subskills: {
      relationship_building: { name: "Relationship Building" },
      active_listening: { name: "Active Listening" },
      communication_style_adaptation: {
        name: "Communication Style Adaptation",
      },
      storytelling: { name: "Storytelling" },
      executive_presence: { name: "Executive Presence" },
      cultural_intelligence: { name: "Cultural Intelligence" },
      trust_building: { name: "Trust Building" },
      conflict_resolution: { name: "Conflict Resolution" },
    },
  },
  product_knowledge_value_creation: {
    name: "Product Knowledge & Value Creation",
    subskills: {
      solution_understanding: { name: "Solution Understanding" },
      business_value_translation: { name: "Business Value Translation" },
      roi_modeling: { name: "ROI Modeling" },
      competitive_differentiation: { name: "Competitive Differentiation" },
      industry_application: { name: "Industry Application" },
      integration_knowledge: { name: "Integration Knowledge" },
      implementation_planning: { name: "Implementation Planning" },
      use_case_expertise: { name: "Use Case Expertise" },
    },
  },
  objection_handling_negotiation: {
    name: "Objection Handling & Negotiation",
    subskills: {
      objection_anticipation: { name: "Objection Anticipation" },
      root_cause_analysis: { name: "Root Cause Analysis" },
      response_formulation: { name: "Response Formulation" },
      evidence_presentation: { name: "Evidence Presentation" },
      emotional_objection_management: {
        name: "Emotional Objection Management",
      },
      negotiation_tactics: { name: "Negotiation Tactics" },
      concession_strategy: { name: "Concession Strategy" },
      win_win_solution_creation: { name: "Win-Win Solution Creation" },
    },
  },
  sales_psychology_influence: {
    name: "Sales Psychology & Influence",
    subskills: {
      emotional_intelligence: { name: "Emotional Intelligence" },
      influence_principles_application: {
        name: "Influence Principles Application",
      },
      behavioral_analysis: { name: "Behavioral Analysis" },
      decision_psychology: { name: "Decision Psychology" },
      persuasion_techniques: { name: "Persuasion Techniques" },
      social_proof_orchestration: { name: "Social Proof Orchestration" },
      authority_positioning: { name: "Authority Positioning" },
      urgency_creation: { name: "Urgency Creation" },
    },
  },
  closing_advancement: {
    name: "Closing & Advancement",
    subskills: {
      buying_signal_recognition: { name: "Buying Signal Recognition" },
      trial_closing: { name: "Trial Closing" },
      closing_technique_selection: { name: "Closing Technique Selection" },
      next_steps_establishment: { name: "Next Steps Establishment" },
      commitment_securing: { name: "Commitment Securing" },
      decision_facilitation: { name: "Decision Facilitation" },
      follow_up_strategy: { name: "Follow-up Strategy" },
      pipeline_advancement: { name: "Pipeline Advancement" },
    },
  },
};

export const subskillSlugToName = Object.values(skillSlugToName).reduce(
  (pv, cv) => ({ ...pv, ...cv.subskills }),
  {} as Record<string, { name: string }>,
);
